/**
 * Builder Step Lock
 *
 * Stops shoppers moving forward in a bundle builder until the current step
 * has its required number of items. Steps without a minimum (e.g. Sibling
 * Gift) can be skipped. Going back is always allowed.
 *
 * It reads what the builder app already shows in its "Your bundle" panel:
 *   - each step's ".bogos-step-items-product-require" text, "4 item(s) required"
 *   - the quantity inputs of the items chosen for that step
 * Nothing in the app is changed. Clicks on the next arrow or on a later
 * step tab are cancelled, with a short message, when a step is incomplete.
 *
 * Works alongside builder-filter.js (occasion as Step 1): step numbers in the
 * message follow window.builderStepOffset.
 */
(function () {
  'use strict';

  var SEL = {
    tab: '.bogos-bp-steps-container .bogos-bp-step-item',
    next: '.bogos-bp-step-next-btn',
    stepsBar: '.bogos-bp-steps-bar',
    summaryStep: '.bogos-step-items-container',
    requireText: '.bogos-step-items-product-require',
    qty: '.bogos-bp-quantity-input'
  };
  var cfg = window.builderStepLockConfig || {};
  var MSG = cfg.message || 'Please add {n} more item(s) to Step {step} before moving on.';
  var msgEl = null;
  var hideTimer = null;

  function tabs() { return document.querySelectorAll(SEL.tab); }

  // The occasion step of builder-filter.js (Kids Step 1) is showing.
  function onOccasionStep() { return !!document.querySelector('.bf-occ-active'); }

  function currentIndex() {
    if (onOccasionStep()) return -1; // before the app's first step
    var t = tabs();
    for (var i = 0; i < t.length; i++) {
      if (t[i].classList.contains('active') || t[i].getAttribute('aria-current') === 'step') return i;
    }
    return 0;
  }

  // Minimum and chosen count for app step i (0-based), from the bundle panel.
  function stepState(i) {
    var box = document.querySelectorAll(SEL.summaryStep)[i];
    if (!box) return { required: 0, chosen: 0 };
    var req = box.querySelector(SEL.requireText);
    var m = req ? /(\d+)/.exec(req.textContent) : null;
    var required = m ? parseInt(m[1], 10) : 0;
    var chosen = 0;
    box.querySelectorAll(SEL.qty).forEach(function (inp) {
      var v = parseInt(inp.value, 10);
      chosen += isNaN(v) ? 1 : v;
    });
    return { required: required, chosen: chosen };
  }

  // First incomplete step between from (inclusive) and to (exclusive), or -1.
  function firstIncomplete(from, to) {
    for (var i = from; i < to; i++) {
      var s = stepState(i);
      if (s.chosen < s.required) return i;
    }
    return -1;
  }

  function showMessage(stepIndex) {
    var s = stepState(stepIndex);
    var shown = stepIndex + 1 + (window.builderStepOffset || 0);
    var text = MSG.replace('{n}', s.required - s.chosen).replace('{step}', shown);
    if (!msgEl || !msgEl.parentNode) {
      var bar = document.querySelector(SEL.stepsBar);
      if (!bar || !bar.parentNode) return;
      msgEl = document.createElement('div');
      msgEl.className = 'bf-step-msg';
      msgEl.setAttribute('role', 'status');
      msgEl.setAttribute('aria-live', 'polite');
      bar.parentNode.insertBefore(msgEl, bar.nextSibling);
    }
    if (msgEl.textContent !== text) msgEl.textContent = text;
    if (msgEl.hidden) msgEl.hidden = false;
    clearTimeout(hideTimer);
    hideTimer = setTimeout(function () { if (msgEl && !msgEl.hidden) msgEl.hidden = true; }, 5000);
  }

  function block(e, stepIndex) {
    e.stopImmediatePropagation();
    e.preventDefault();
    showMessage(stepIndex);
  }

  function targetOf(t) {
    if (t.closest(SEL.next)) return currentIndex() + 1;
    var tab = t.closest(SEL.tab);
    if (!tab) return -1;
    return Array.prototype.indexOf.call(tabs(), tab);
  }

  function onClick(e) {
    var t = e.target;
    if (!t || !t.closest) return;
    // No occasion yet: builder-filter.js asks for one, so stay out of the way.
    var bf = window.builderFilter;
    if (onOccasionStep() && bf && bf.occasion && !bf.occasion.chosen) return;
    var target = targetOf(t);
    if (target < 0) return;
    var cur = currentIndex();
    var bad = target > cur ? firstIncomplete(Math.max(cur, 0), target) : -1; // going back is always fine
    if (bad !== -1) block(e, bad);
    else if (msgEl && !msgEl.hidden) msgEl.hidden = true; // moving on: clear any old warning
  }

  function onKey(e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    onClick(e);
  }

  function injectStyles() {
    var css = document.createElement('style');
    css.textContent =
      '.bf-step-msg{margin:10px 0 0;padding:8px 12px;border-radius:6px;background:#fff6e5;color:#7a5a12;font-size:14px;text-align:center}' +
      '.bf-step-msg[hidden]{display:none}';
    document.head.appendChild(css);
  }

  function init() {
    if (window.builderStepLock) return; // once per page
    window.builderStepLock = { stepState: stepState, firstIncomplete: firstIncomplete };
    injectStyles();
    document.addEventListener('click', onClick, true);
    document.addEventListener('keydown', onKey, true);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
